import { hash } from './hash';

/** Preserve the original signed FNV hue mapping, including the empty name. */
export function hue(text: string): number {
  return Math.abs(text.length ? hash(text) | 0 : hash(text)) % 360;
}
